import { useState, useMemo } from 'react';
import { LTR, SUPPORTED_LANGUAGES } from 'arbitrip-common/translation/const';
import AmenitiesComponent from './AmenitiesComponent.react.js';
import { useTranslation } from 'react-i18next';
import TranslationToggleNotice from '@/components/general/TranslationToggleNotice.jsx';

const Amenities = ({ base, translations, durationMs }) => {
	const { i18n, t } = useTranslation();
	const lang = i18n?.language;
	const translated = lang && lang !== SUPPORTED_LANGUAGES.EN ? translations?.[lang] : null;
	const translatedExists = Array.isArray(translated) ? translated.length > 0 : !!translated;
	const [showOriginal, setShowOriginal] = useState(false);
	const dirForContent = useMemo(() => (showOriginal ? LTR : i18n.dir()), [showOriginal, i18n]);
	const amenities = !showOriginal && translatedExists ? translated : base || [];

	if (!Array.isArray(amenities) || amenities.length === 0) return null;

	return (
		<div className="amenities-container">
			<TranslationToggleNotice
				translatedExists={translatedExists}
				showOriginal={showOriginal}
				onToggle={() => setShowOriginal((v) => !v)}
				durationMs={durationMs}
			/>
			<div dir={dirForContent}>
				<AmenitiesComponent amenities={amenities} />
			</div>
		</div>
	);
};

export default Amenities;
